import axios from 'axios';

const DEXSCREENER_BASE_URL = 'https://api.dexscreener.com';

export interface DexScreenerSocial {
  type: string;
  url: string;
}

export interface DexScreenerWebsite {
  label?: string;
  url: string;
}

export interface DexScreenerTokenInfo {
  imageUrl?: string;
  header?: string;
  openGraph?: string;
  websites?: DexScreenerWebsite[];
  socials?: DexScreenerSocial[];
}

export interface DexScreenerToken {
  address: string;
  name: string;
  symbol: string;
}

export interface DexScreenerPair {
  chainId: string;
  dexId: string;
  url: string;
  pairAddress: string;
  baseToken: DexScreenerToken;
  quoteToken: DexScreenerToken;
  priceNative?: string;
  priceUsd?: string;
  txns?: Record<string, any>;
  volume?: Record<string, any>;
  priceChange?: Record<string, any>;
  liquidity?: { usd?: number; base?: number; quote?: number };
  fdv?: number;
  marketCap?: number;
  pairCreatedAt?: number;
  info?: DexScreenerTokenInfo;
}

export interface DexScreenerTokenResponse {
  schemaVersion: string;
  pairs: DexScreenerPair[] | null;
}

export const dexscreenerApi = {
  /**
   * 토큰 주소로 DexScreener 페어 데이터를 조회합니다.
   * https://api.dexscreener.com/latest/dex/tokens/{tokenAddress}
   */
  async getTokenPairs(tokenAddress: string): Promise<DexScreenerTokenResponse | null> {
    try {
      const response = await axios.get<DexScreenerTokenResponse>(
        `${DEXSCREENER_BASE_URL}/latest/dex/tokens/${tokenAddress}`,
      );
      return response.data;
    } catch (error) {
      console.error(`[DexScreener] Failed to fetch pairs for ${tokenAddress}:`, error);
      return null;
    }
  },
};
